export * from './MainText'
